import type { ViewConfigKpi, ViewConfigSheet } from '../../../../schemas/view_config/index.ts'
import { getNodeByName } from '../../../util/node.ts'
import type { CompileContext } from '../../common.ts'
import { generateSalescoreUserNode } from './generateSalescoreUserGroupTree.ts'

export function addSalescoreUserTree(
  config: ViewConfigSheet,
  user: ViewConfigKpi['user'],
  context: CompileContext,
  date?: ViewConfigKpi['date'],
): ViewConfigSheet {
  if (user === undefined) {
    return config
  }
  if (config.tree === undefined) {
    // ありえないはず
    return config
  }

  // 破壊的操作でsalescore_users_with_groupをjoinする
  // eslint-disable-next-line sonarjs/todo-tag
  const newTree = structuredClone(config.tree) // TODO
  const nodeWithUserProperty = getNodeByName(newTree, user.property.nodeName)?.node
  if (nodeWithUserProperty === undefined) {
    context.logs.error(`ユーザーフィールドのノードが見つかりませんでした。${user.property.nodeName}`)
    return config
  }

  const modelProperty = context.modelSearcher.searchProperty(user.property.modelName, user.property.propertyName)
  const enableHistoricalGroupResolution =
    context.additionalConfig?.kpiParameter?.enableHistoricalGroupResolution === true
  const newNode = generateSalescoreUserNode(user, modelProperty, {
    enableHistoricalGroupResolution,
    dateProperty: enableHistoricalGroupResolution ? date?.property : undefined,
  })
  nodeWithUserProperty.children ??= []

  if (newNode !== undefined) {
    nodeWithUserProperty.children.push(newNode)
  }

  return {
    ...config,
    tree: newTree,
  }
}
